"use strict";

require("core-js/modules/es6.object.keys.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  IMPRESSION_REPORTED: true,
  impressionReported: true
};
exports.impressionReported = exports.IMPRESSION_REPORTED = void 0;

var _impressions = require("../shared/actions/impressions");

Object.keys(_impressions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _impressions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _impressions[key];
    }
  });
});
var IMPRESSION_REPORTED = 'IMPRESSION_REPORTED';
exports.IMPRESSION_REPORTED = IMPRESSION_REPORTED;

var impressionReported = function impressionReported(elementId, eventData) {
  return {
    type: 'IMPRESSION_REPORTED',
    elementId: elementId,
    eventData: eventData
  };
};

exports.impressionReported = impressionReported;